import { render, staticRenderFns } from "./ItemProperties.vue?vue&type=template&id=075a6e24"
import script from "./ItemProperties.vue?vue&type=script&lang=js"
export * from "./ItemProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports